export interface IPolicy {
  policyType: PolicyType;
  html: string;
}

export enum PolicyType {
  PRIVACY = 'Privacy Policy',
  SHIPPING = 'Shipping Policy',
  TERMS_OF_SERVICE = 'Terms of Service',
  REFUND = 'Refund Policy'
}